/**
 * Khung xương lúc chờ dữ liệu.
 *
 * Gom ở bước 12.2: trước đó 7 chỗ tự viết `animate-pulse bg-neutral-nen` với
 * chiều cao và bo góc khác nhau. Mọi khối chờ nên dùng component này để nhịp
 * nhấp nháy và màu giống nhau trên cả app.
 */
export interface SkeletonProps {
  /** Chiều cao CSS, ví dụ `'240px'` hoặc `'1.25rem'`. */
  cao?: string;
  /** Chiều rộng CSS. Mặc định chiếm hết. */
  rong?: string;
  /** Bo góc. `'the'` cho khối lớn, `'nho'` cho dòng chữ. */
  bo?: 'the' | 'vua' | 'nho' | 'tron';
  className?: string;
}

const BO: Record<NonNullable<SkeletonProps['bo']>, string> = {
  the: 'rounded-the',
  vua: 'rounded-[12px]',
  nho: 'rounded',
  tron: 'rounded-full',
};

export function Skeleton({ cao = '1.25rem', rong, bo = 'nho', className = '' }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={`block animate-pulse bg-neutral-nen ${BO[bo]} ${className}`}
      style={{ height: cao, ...(rong ? { width: rong } : {}) }}
    />
  );
}

/** Nhiều dòng khung xương xếp dọc, dùng cho danh sách đang tải. */
export function DanhSachSkeleton({
  so = 5,
  cao = '1.25rem',
  className = 'flex flex-col gap-4',
}: {
  so?: number;
  cao?: string;
  className?: string;
}) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: so }).map((_, i) => (
        <Skeleton key={`khung-${String(i)}`} cao={cao} />
      ))}
    </div>
  );
}
